import React, { useRef } from 'react';
import {
  PiPlay,
} from 'react-icons/pi';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

export default function Handler() {
  if (process.env.REACT_APP_TOOLBAR_RUN_ANALYSIS !== 'true') return false;

  const fileInputRef = useRef();

  const handleRun = () => {
    // TODO: Modal - redirect notice, "what's next", etc
    window.open(
      'http://localhost:8888/notebooks/work/swede/clients/csiro/jupyter/qmm-tests.ipynb?model=MODEL_NAME',
      'qmm-tests.ipynb', // or _blank
    );
  };

  return (
    <>
      <Autocomplete
        freeSolo
        size="small"
        options={[{ label: 'Qualitative mathematical modelling in python', file: 'qmm.ipynb' }]}
        sx={{ ml: 3, minWidth: 300 }}
        renderInput={
          /* eslint-disable react/jsx-props-no-spreading */
          (params) => <TextField {...params} label="Analysis" />
        }
      />
      <IconButton
        value=""
        title="Run Analysis"
        sx={{ ml: 1 }}
        variant="outlined"
        onClick={handleRun}
      >
        <PiPlay />
      </IconButton>
      <input
        ref={fileInputRef}
        type="file"
        accept=".json"
        onClick={(event) => {
          // eslint-disable-next-line
          event.target.value = null; // allow same file to be loaded (e.g after "New")
        }}
        style={{ display: 'none' }}
      />
    </>
  );
}
